import { useParams } from "react-router-dom";
import ContractEditPage from "./components/edit/ContractEditPage";
import ContractEditBasedOnPoPage from "./components/edit/ContractEditBasedOnPo";
import { useGetContractQuery } from "@/src/store/apis/contracts";
import { useGetExporterContractSignatureHistoriesQuery } from "@/src/store/apis/contracts/contractDetail";

const ExporterContractEditPage = () => {
  const params = useParams();

  // API
  const { signatureStatus, contractStatus, isRejected, contractData } =
    useGetContractQuery(
      {
        id: Number(params.id),
      },
      {
        refetchOnMountOrArgChange: true,
        selectFromResult: ({ isFetching, currentData }) => {
          return {
            isContractFetching: isFetching,
            signatureStatus: currentData?.row.signatureStatus,
            contractStatus: currentData?.row.contractStatus,
            isRejected: currentData?.row.isRejected,
            contractData: currentData?.row,
          };
        },
      }
    );
  const {
    isImporterSignedSC,
    isExporterSignedSC,
    isExporterSignedPO,
    isImporterSignedPO,
    rejectReason,
    currentSignature,
  } = useGetExporterContractSignatureHistoriesQuery(
    {
      id: Number(params.id),
    },
    {
      refetchOnMountOrArgChange: true,
      selectFromResult: ({ currentData, isFetching }) => {
        const currentSignature = currentData?.rows[0];
        return {
          isSignatureFetching: isFetching,
          isImporterSignedSC: currentSignature?.isImporterSignedSC,
          isExporterSignedSC: currentSignature?.isExporterSignedSC,
          isExporterSignedPO: currentSignature?.isExporterSignedPO,
          isImporterSignedPO: currentSignature?.isImporterSignedPO,
          rejectReason: currentSignature?.rejectReason,
          currentSignature: currentSignature,
          isAllSignedBefore: currentData?.rows.some(
            (sign) =>
              sign.isExporterSignedPO &&
              sign.isExporterSignedSC &&
              sign.isImporterSignedPO &&
              sign.isImporterSignedSC
          ),
        };
      },
    }
  );

  /**
   * 기본 수정폼(전체수정 폼)
   * - 거래처와 미연동일 경우
   * - 서명이 모두 연결이 되어있는 상태에서 수정(버전업)
   * - SC처음부터 반려되었을경우(서명모두 false)
   * - SC가 반려된 경우 (isRejected가 true이거나 rejectReason이 있음)
   * - PO가 아직 생성되지 않은 경우 (양쪽 모두 PO 서명이 없음)
   */
  const isSCBasicForm =
    contractStatus === "NOT_LINKED" ||
    signatureStatus === "LINKED" ||
    (signatureStatus === "PENDING" &&
      !isImporterSignedSC &&
      !isExporterSignedSC &&
      !isExporterSignedPO &&
      !isImporterSignedPO) ||
    (signatureStatus === "PENDING" && (isRejected || !!rejectReason)); // SC가 반려된 경우

  return (
    <div>
      {isSCBasicForm ? (
        <ContractEditPage />
      ) : (
        <ContractEditBasedOnPoPage id={Number(params.id)} />
      )}
    </div>
  );
};

export default ExporterContractEditPage;
